<template>
    <div>
        <ServiceRequired
            :account-id="accountId"
            :referral-options="referralOptions"
            v-on:updateServicesRequired="updateServicesRequired"
        />
        <PatientDiagnosis class="mt-2" />
        <ClinicalComments class="mt-2" />
    </div>
</template>

<script lang="ts" src="./ClinicalDiagnosis.ts"></script>

<style lang="scss">
.no-border-radius {
    border-radius: 0 !important;
}
</style>
